import { ReviewData } from "../../../../common/types";
import {Carousel, Avatar} from "antd";
import React, {useEffect, useState} from "react";
import "./ReviewsCarousel.css";
import { getCurrentLang } from "../../../../common/utils/lang";
import Section from "../section/Section";

interface Props {
  reviews: ReviewData[];
}

const ReviewsCarousel = ({ reviews }:Props) => {
    const [pageWidth, changeWidth] = useState<number>(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {changeWidth(window.innerWidth)};
        window.addEventListener('resize', handleResize);

        return () => {window.removeEventListener('resize', handleResize);};
    }, [changeWidth]);

    let arrayOfArrays:ReviewData[][] = [];
    const elementsInARow = pageWidth <= 767 ? 1 : 4;
    reviews.forEach(review => {
        if (arrayOfArrays.length === 0 || arrayOfArrays[arrayOfArrays.length-1].length === elementsInARow) {
            arrayOfArrays = [...arrayOfArrays, [review]];
        } else {
            arrayOfArrays[arrayOfArrays.length-1] = [...arrayOfArrays[arrayOfArrays.length-1], review]
        }
    });

    return (
        <Section titlePath="home.feedback.title">
            <div className="reviews-carousel">
                <Carousel dots={{"className": "reviews-dots"}}>
                    {arrayOfArrays.map(reviewItemsList(elementsInARow))}
                </Carousel>
            </div>
        </Section>
  );
};

const reviewItemsList = (elementsInARow:number) => (reviews: ReviewData[], index: number) => {
    const justify = reviews.length === elementsInARow ? "justify-between" : "justify-start";
    return <div key={`g${index}`}>
        <div className={`grid grid-cols-1 grid-rows-1 md:grid-cols-2 md:grid-rows-2 gap-[20px] pb-[50px] ${justify}`}>
            {reviews.map(reviewItem(elementsInARow))}
        </div>
    </div>

};

const reviewItem = (elementsInARow:number) => (review: ReviewData, index: number) => {
    const lang = getCurrentLang();

    return <div key={`r${index}`} className={`h-[314px] text-[#252429]`}>
        <div className="relative h-[176px] bg-white p-[31px] text-[20px] leading-[30px] rounded-[12px]">
            {/* <Rate value={review.rating} />
            <h2 className="mt-[18px] mb-1 text-xl">{review.comment[lang]}</h2> */}
            <div className="w-full h-full overflow-hidden">
                <p className="mt-0 text-base text-ellipsis">{review.details[lang]}</p>
            </div>
            <div className="absolute -z-10 -bottom-4 left-[50px] bg-white w-[50px] h-[50px] skew-x-[10deg] skew-y-[10deg] rotate-45 rounded-[5px]"></div>
        </div>
        <div className="mt-auto flex justify-start items-center gap-[17px] pt-[36px]">
            <div>
                <Avatar className="border-solid border-2 border-white" size={90} src={review.reviewer.photo} />
            </div>
            <div>
                <p className="text-xl mb-[7px]">{review.reviewer.name[lang]}</p>
                <p className="text-base mb-0">{review.reviewer.position[lang]}</p>
            </div>
        </div>
    </div>;

};

export default ReviewsCarousel;
